module.exports = __webpack_public_path__ + "static/media/bg-header.65d1c74b.png";